import React, { createContext, useContext, useState } from 'react';

/**
 * Lets a page publish a dynamic breadcrumb trail to the global Header.
 *
 * The Header derives breadcrumbs from the URL alone, which is fine for static
 * pages but can't know things like a patient's name or an encounter date. A
 * page can call `setCrumbs([...])` (typically in an effect once its data has
 * loaded) to override the derived trail, and clear it on unmount.
 *
 * Each crumb is `{ label: string, to?: string }`. A crumb with `to` renders as
 * a link in the Header; the last crumb is always shown as plain (active) text.
 */
const BreadcrumbContext = createContext({ crumbs: null, setCrumbs: () => {} });

export function BreadcrumbProvider({ children }) {
  const [crumbs, setCrumbs] = useState(null);
  return (
    <BreadcrumbContext.Provider value={{ crumbs, setCrumbs }}>
      {children}
    </BreadcrumbContext.Provider>
  );
}

export const useBreadcrumb = () => useContext(BreadcrumbContext);

export default BreadcrumbContext;
